import { useEffect, useRef } from 'react'
import styled from 'astroturf/react'
import { Popup, Header, Footer } from '@calendly/ui/components/popup'
import { Button } from '@calendly/ui/components/button'
const colorTextDestructive = 'var(--colorTextDestructive, var(--coreColorRed700))'
import { RecaptchaChallenge } from '@calendly/recaptcha'

import { useI18n } from 'locales'
import _CenteredContainer from "recaptcha_popup-CenteredContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/recaptcha_popup.js?styleId=CenteredContainer";
import _ErrorText from "recaptcha_popup-ErrorText.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/recaptcha_popup.js?styleId=ErrorText";


const CenteredContainer = /*#__PURE__*/styled('div', null, {
  displayName: "CenteredContainer",
  styles: _CenteredContainer
})
const ErrorText = /*#__PURE__*/styled('p', null, {
  displayName: "ErrorText",
  styles: _ErrorText
})

const RecaptchaPopup = ({ onClose, onConfirm, setVerifyCallback, loading, challengeFailed, segmentAnalyticsCallback, interactionType }) => {
  const { i18n } = useI18n()
  const focusedRef = useRef()
  const lastInteractionType = useRef(null)

  useEffect(() => {
    focusedRef.current.focus()
  }, [focusedRef])

  useEffect(() => {
    if (segmentAnalyticsCallback && lastInteractionType.current !== interactionType) {
      segmentAnalyticsCallback()
      lastInteractionType.current = interactionType
    }
  }, [interactionType, segmentAnalyticsCallback])

  return (
    <Popup onClose={onClose} withCloseButton>
      <Header
        title={i18n.t('booking.recaptcha.confirm_youre_human')}
      />
      <CenteredContainer>
        <div>
          <RecaptchaChallenge
            setVerifyCallback={setVerifyCallback}
            error={challengeFailed}
          />
          {challengeFailed && <ErrorText>{i18n.t('booking.recaptcha.error')}</ErrorText>}
        </div>
      </CenteredContainer>
      <Footer>
        <Button ref={focusedRef} onClick={onConfirm} loading={loading}>
          {i18n.t('booking.action.continue')}
        </Button>
      </Footer>
    </Popup>
  )
}

export default RecaptchaPopup
